import React from 'react';

export const DISCLAIMER_0 = (
  <>
    <sup>*</sup>
    Subject to credit approval and verification. Actual approved loan amount and terms are
    dependent on standard underwriting guidelines and credit policies. Funds may be deposited
    for delivery to your bank via ACH as soon as the same business day if verification is
    completed and final approval occurs before 12:00 PM CT on a business day. If approval occurs
    after 12:00 PM CT on a business day or on a non-business day, funds may be delivered as soon
    as the next business day. Availability of the funds is dependent on how quickly your bank
    processes the transaction.
  </>
);

export const DISCLAIMER_1 = (
  <>
    <sup>1</sup>
    OppLoans may use credit report information provided by Clarity Services and Experian as part
    of the application process to determine your creditworthiness. Neither credit inquiry will
    appear as a hard credit inquiry on your Experian credit report and therefore they will not
    affect your FICO score.
  </>
);
